module.exports = __webpack_public_path__ + "img/sd_bg.762e5232.png";